// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__2BbLO","success":"Button_success__2qYq8","alert":"Button_alert__Oc3Wz"};